<template>
  <div class="container-fluid" id="intro">
    <div class="row wrapper">
      <div class="col-12 col-md-4 side-banner">
        <div class="header">
          <!-- <h2 class="mt-2 mb-1">&nbsp;</h2> -->
          <div class="company-logo mb-4"></div>
          <div class="hero-image" alt="Your insurance needs"></div>
        </div>
      </div>
      <div class="col-12 col-md-8 main-banner">
        <div class="main">
          <ValidationObserver v-slot="{ handleSubmit }" ref="form">
            <form @submit.prevent="handleSubmit(onSubmit)">
              <h1 tabindex="0">Before you begin</h1>
              <p>Before you calculate your cover, you'll need to read some background information about our insurance calculator. Below we cover:</p>
              <ul>
                <li>its purpose</li>
                <li>how it works</li>
                <li>conditions, limitations and general advice considerations</li>
              </ul>
              <p>After you read the background information in full, you'll be able to accept the assumptions and disclaimer.</p>
              <div class="disclaimer-content disclaimer-text" tabindex="0" @scroll="watchMeScroll">
                <section v-html="pageContent.pages.beforeWeBeginCopy"></section>
                <span ref="end"></span>
              </div>

              <ValidationProvider class="col col-md-12" name="acceptedDisclaimer" :rules="{ required: { allowFalse: false, msg: 'To proceed, you must read the background information and accept the disclaimer and assumptions.' } }" v-slot="{ errors }" ref="myinput">

                <label class="checkbox-wrapper" @click="validateField('myinput')">
                  <input type="checkbox" id="acceptedDisclaimer" name="acceptedDisclaimer" tabindex="0" @change="clickDisclaimer" v-model="acceptedDisclaimer" @blur="triggerHeightCheck()" data-analytics-capture-value="true" :disabled="scrolledToEnd == false && enableDisclaimer == false" />
                  <span class="checkmark"></span>
                  <span>I have read the background information and accept the <router-link class="assumption-button col" :to="{ name: 'Assumptions', params: {activeTab: 'disclaimer' } }" tabindex="0">disclaimer and assumptions.</router-link></span>
                </label>


                <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
              </ValidationProvider>

              <div class="nav-button row">

                <router-link class="back-button col" to="/" tabindex="0" role="button">Back</router-link>
                <button class="next-button col" v-bind:class="[acceptedDisclaimer ? 'is-active' : 'is-disabled']" tabindex="0" role="button" type="submit" v-on:click="triggerHeightCheck">Next</button>
              </div>
            </form>
          </ValidationObserver>

        </div>
      </div>
    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>

import { mapFields } from "vuex-map-fields";
import { mapGetters } from 'vuex';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import CustomFooter from '../components/CustomFooter';
import { ref } from "vue";
import { useElementVisibility } from "@vueuse/core";

extend('required', {
  ...required,
  params: ['msg'],
  message: '{msg}'
});



export default {
  setup() {
    const end = ref(null);
    let scrolledToEnd = useElementVisibility(end);
    return {
      end,
      scrolledToEnd,
    }
  },
  name: 'Intro',
  props: ['choice'],
  components: {ValidationProvider, ValidationObserver, CustomFooter},
  computed: {
    ...mapFields(["acceptedDisclaimer", "enableDisclaimer"]),
    ...mapGetters(["pageContent",]),
  },
  methods: {
    validateField (field) {
      const provider = this.$refs[field];
      return provider.validate();
    },
    clickDisclaimer(e) {
      this.$store.commit("updateAcceptedDisclaimer",e.target.checked);
      this.triggerHeightCheck();
    },
    watchMeScroll () {
      if(this.scrolledToEnd){
        this.$store.commit("updateEnableDisclaimer",true);
      }
    },
    onSubmit () {
      const premiumsOnly = this.choice === 'next-options';
      this.$store.commit("updateSkipCalculations", premiumsOnly);
      this.$router.push(`/${this.choice}`);
      this.triggerHeightCheck();
    },
    triggerHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
  },
  mounted() {
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  }
};
</script>
